import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";

interface StoreInfo {}

@Module
export default class TagsModule extends VuexModule implements StoreInfo {

  tagsPagination = {
    pagination: [] || null,
    loading: true,
    error: null,
  };

  tagsFilters = {
    search: "",
    page: 1,
    searchString: "",
    limit: parseInt(process.env.VUE_APP_PAGINATION || "20"),
  };
  
  tags = null
  tag = null
  allTags = null

  /* --- GETTERS --- */

  get getAllTags() {
    // //console.log("getter tags", this.tags)
    return this.allTags;
  }


  get getTags() {
    // //console.log("getter tags", this.tags)
    return this.tags;
  }


  get getTag() {
    ////console.log("TAGS", this.tag)
    return this.tag;
  }

  get getTagsPagination() {
      // //console.log("getter 2", this.tagsPagination)
      return this.tagsPagination;
  }

  get getTagsFilters() {
    return this.tagsFilters;
  }

  get getPageTags() {
    return this.tagsFilters.page;
  }

  /* --- MUTATIONS --- */

  @Mutation
  [Mutations.SET_TAGS_PAGINATION]({pagination, loading, error}) {
    // //console.log('departments mutation',payload);
    this.tagsPagination = {
      pagination: pagination,
      loading,
      error
    };
  }


  @Mutation
  [Mutations.SET_PAGE_PAGINATION_TAGS](payload) {
    this.tagsFilters.page = payload;
  }

  @Mutation
  [Mutations.SET_TAGS](payload) {
    ////console.log('mutation',payload);
    this.tags = payload;
  }

  @Mutation
  [Mutations.SET_TAG_BY_ID](payload) {
    ////console.log('mutation',payload);
    this.tag = payload;
  }

  @Mutation
  [Mutations.SET_ALL_TAGS](payload) {
    ////console.log('mutation',payload);
    this.allTags = payload;
  }

  @Mutation
  [Mutations.SEARCH_TAGS]({payload, pagination, loading, error}) {
    ////console.log('mutation',payload);
    ////console.log('mutation',pagination);

    const filteredData = pagination?.data.filter((tag: any) => tag.name.toLowerCase().includes(payload.toLowerCase()));
    const newPagination = {
      ...pagination,
      data: filteredData,
    };

    this.tagsPagination = {
      pagination: newPagination,
      loading,
      error
    };

  }

  @Mutation
  [Mutations.FILTER_TAGS](payload) {
    this.tagsFilters.searchString = payload
  }

  @Mutation
  [Mutations.CLEAR_TAGS_FILTERS](payload) {
    this.tagsFilters = {
      search: "",
      page: 1,
      searchString: "",
      limit: parseInt(process.env.VUE_APP_PAGINATION || "20"),
    };
  }



  /* --- ACTIONS --- */

  @Action
  [Actions.SET_PAGE_PAGINATIONS_TAGS](payload) {
    this.context.commit(Mutations.SET_PAGE_PAGINATION_TAGS, payload.page);
    this.context.dispatch(payload.getAction);
  }

  @Action({ rawError: true })
  [Actions.SEARCH_TAGS](payload) {
    ApiService.get(`tags`)
      .then(({ data }) => {
        this.context.commit(Mutations.SEARCH_TAGS, {
          payload: payload,
          pagination: data,
          loading: false,
          error: null,
        });
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action({ rawError: true })
  [Actions.GET_ALL_TAGS](payload) {
    ApiService.get(`alltags`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ALL_TAGS, 
         data
        );
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action({ rawError: true })
  [Actions.FILTER_TAGS](payload) {
    this.context.commit(Mutations.FILTER_TAGS, payload);
    this.context.dispatch(Actions.GET_TAGS_WITH_PAGINATION)
  }


  @Action
  [Actions.GET_TAGS]() {
    // //console.log(this.tagsFilters.searchString)
    return ApiService.get(
      `tags`
    )
      .then(({ data }) => {
        // //console.log(data);
        //this.context.commit(Mutations.SET_TAGS, data)
        this.context.commit(Mutations.SET_TAGS, data)
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.GET_TAGS_WITH_PAGINATION]() {
    // //console.log(this.tagsFilters.searchString)
    return ApiService.get(
      `tags?page=${this.tagsFilters.page}&search=${this.tagsFilters.search}${this.tagsFilters.searchString}`
    )
      .then(({ data }) => {
        // //console.log(data);
        //this.context.commit(Mutations.SET_TAGS, data)
        this.context.commit(Mutations.SET_TAGS_PAGINATION, {
          pagination: data,
          loading: false,
          error: null,
        })
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.GET_TAG_BY_ID](payload) {
    //console.log(this.tagsFilters.searchString)
    return ApiService.get(`tags/${payload}`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_TAG_BY_ID, data)
        return data
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.PUT_TAG](payload) {
    const {id, tag} = payload;

    return ApiService.put(`tags/${id}`, tag)
      .then(({ data }) => {
        this.context.dispatch(Actions.GET_TAGS_WITH_PAGINATION)
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.CREATE_TAG](payload) {

    return new Promise((resolve, reject) => {
      //console.log('crear tag', payload)
     ApiService.post(`tags`, payload)
      .then(({ data }) => {
        resolve(data)
        //console.log('store gooood',data);
        this.context.dispatch(Actions.GET_TAGS_WITH_PAGINATION)
      })
      .catch(({ response }) => {
        reject(response.data.errors);
        //console.log('store error', response);
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
    });
  }

  @Action
  [Actions.DELETE_TAG](payload) {
    return ApiService.delete(`tags/delete/${payload}`)
      .then(() => {
        this.context.dispatch(Actions.GET_TAGS_WITH_PAGINATION);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.CLEAR_TAGS_FILTERS](payload) {
    this.context.commit(Mutations.CLEAR_TAGS_FILTERS, payload);
    this.context.dispatch(Actions.GET_TAGS);
  }

}
